import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import ZoomOutMapIcon from '@material-ui/icons/ZoomOutMap'
import RBarButton from './RBarButton'
import {
  modeSelector,
  MODE,
  rotateRight
} from '../../../modules/reducerRotator'

const useStyles = makeStyles((theme) => ({
  root: {}
}))

const RFullWindowButton = (props) => {
  const classes = useStyles()

  const mode = useSelector(modeSelector)
  const dispatch = useDispatch()

  const handleClick = useCallback(() => {
    dispatch(rotateRight(1))
  }, [dispatch])

  return (
    <RBarButton
      {...props}
      tooltip="Full window"
      onClick={handleClick}
      disabled={mode !== MODE.BUTTONS}
    >
      <ZoomOutMapIcon fontSize="inherit" />
    </RBarButton>
  )
}
export default RFullWindowButton
